interface Props {
  file: File;
  onRemove: () => void;
}

function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function FileChip({ file, onRemove }: Props) {
  return (
    <div className="file-chip">
      <span className="name">{file.name}</span>
      <span className="size">{formatBytes(file.size)}</span>
      <button className="remove" onClick={onRemove} aria-label="Remove file" type="button">
        ×
      </button>
    </div>
  );
}
